import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { VsmeCycleToolbar } from '@/features/vsme/components/VsmeCycleToolbar';
import { VsmeMobileNav } from '@/features/vsme/components/VsmeMobileNav';
import { VsmeNav } from '@/features/vsme/components/VsmeNav';
import { VsmeReportProvider } from '@/features/vsme/hooks/use-vsme-report-context';

export const Route = createFileRoute('/_authenticated/vsme')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/vsme') {
      // TanStack Router expects redirect to be thrown as control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/vsme/overview' });
    }

    return {
      getTitle: () => 'VSME Reporting',
    };
  },
  component: VsmeLayout,
});

function VsmeLayout() {
  const { t } = useTranslation('vsme');
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <VsmeReportProvider>
      <div className="flex min-h-[calc(100vh-4rem)]">
        <VsmeNav />
        <VsmeMobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

        <div className="flex-1 overflow-auto">
          <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => {
                setMobileNavOpen(true);
              }}
              aria-label={t('nav.ariaLabel')}
              className="h-11 w-11"
            >
              <Menu className="h-5 w-5" />
            </Button>
            <span className="ml-2 text-sm font-medium text-muted-foreground">{t('nav.title')}</span>
          </div>
          <VsmeCycleToolbar />
          <Outlet />
        </div>
      </div>
    </VsmeReportProvider>
  );
}
